/**
 * Utility functions for generating consistent page titles
 */

import { BRAND_NAME } from "../constants/layout";

/**
 * Generates a consistent page title with the brand name
 * @param pageTitle - The specific page title
 * @returns Formatted page title
 */
export const generatePageTitle = (pageTitle: string): string => {
  if (!pageTitle) return BRAND_NAME;

  const baseTitle = pageTitle.trim();

  return `${baseTitle} | ${BRAND_NAME}`;
};

/**
 * Generates page title for content pages (articles, events, etc.)
 * @param contentTitle - The content title
 * @param contentType - Type of content (article, événement, etc.)
 * @returns Formatted content title
 */
export const generateContentTitle = (contentTitle: string, contentType?: string): string => {
  const typePrefix = contentType ? `${contentType} - ` : '';
  return generatePageTitle(`${typePrefix}${contentTitle}`);
};

/**
 * Page title for SEO purpose.
 */
export const getPageTitle = ({
  title,
  skipBrandName = false
}: {
  title?: string;
  skipBrandName?: boolean
}): string => {
    if (!title) return BRAND_NAME;
    if (skipBrandName) return title;
    if (title.includes(`| ${BRAND_NAME}`)) return title;
    return generatePageTitle(title);
  };
